import { useCallback } from "react";

import { ButtonProps } from "../interfaces";

export const useButton = ({ onClick, onKeyDown, loading }: ButtonProps) => {
  // Handle click with blur to prevent focus state after click
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      if (typeof onClick === "function" && !loading) {
        onClick(e);
      }
      // Remove focus after clicking
      e.currentTarget.blur();
    },
    [loading, onClick],
  );

  return { handleClick };
};
